<template>
    <div class="modal fade" id="printviewdisbursementcollectioncenterwise">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printdisbursementcollectioncenterwise()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printdisbursementcollectioncenterwise">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <table class="table table-condensed">
                        <thead>
                          <td><img :src="logo" height="100" width="100%"></td>
                          <td class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small><br><br><strong>LOAN APPLICATION FORM</strong></h4></td>
                        </thead>
                      </table>
                      <hr width="100%">
                        <p>We here by agree that we are forming a group for loan(IGL) to income generation purpose and we will follow  all rules and regulations of {{getCompanyRecord.companyName}} and also  mutually agree to pay all dues and EMI of {{getCompanyRecord.companyName}} and we are also agree to arrange a weekly meeting to loan payment purpose.</p>
                        <div class="info-box"  v-if="canAccess('loan-disbursement-view-any')">
                            <div class="box-header with-border">
                            <h3 class="box-title">Group Disbursement List</h3>
                            
                            <div class="box-tools">
                                <!-- <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('member-create')">
                                <i class="fa fa-plus"></i> Add New
                                </button> -->
                            </div>

                            </div>
                            <div class="box-body">
                            <div class="row">
                                <div class="col-sm-6 col-xs-6">
                                    <label v-if="Object.keys(branch).length !== 0">
                                       Branch : {{branch.name}} ({{branch.branchCode}}) <br>
                                       Group Leader : {{seeRecords[0].collection_center_leader.name}}
                                    </label>
                                </div>
                                <div class="col-sm-6 col-xs-6">
                                    <div class="pull-right">
                                        <label v-if="Object.keys(collectionCenter).length !== 0">
                                            Group Name : {{collectionCenter.name}} <br>
                                            Address: {{collectionCenter.address}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <table class="table table-sm table-bordered table-hover">
                                <thead style="background-color: #d6dddd;">
                                <tr>
                                    <th class="hidden-xs">Sr.</th>
                                    <th>Member</th>
                                    <th>Guarantor</th>
                                    <th class="hidden-xs">Loan Type</th>
                                    <th class="hidden-xs">Loan Cycle</th>
                                    <th>Loan Amt</th>
                                    <th>Loan Tenure</th>
                                    <th>Loan Purpose</th>
                                    <!-- <th class="hidden-xs">Dis Dt</th>
                                    <th class="hidden-xs">Emi Start Dt </th>
                                    <th class="hidden-xs">Emi End Dt </th> -->
                                    <!-- <th>Group</th> -->
                                    
                                    <!-- <th class="hidden-xs">Staff</th> -->
                                    <th class="hidden-xs">Member Signature</th>
                                    <!-- <th class="hidden-xs">Pay Mode</th> -->
                                </tr>
                                </thead>
                                <tbody v-for="(row, index) in seeRecords" :key="index">
                                  <tr>
                                    <td rowspan="2" class="hidden-xs">{{ (index + 1) }}</td>
                                    <td><i v-if="row.member">{{ row.member.name }}<br>({{ row.member.code }})</i></td>
                                    <td><span v-if="row.guarantor">{{row.guarantor.name}}<br>({{row.guarantor.code}})</span></td>
                                    <td class="hidden-xs">{{ planName(row.plan) }}</td>
                                    <td class="hidden-xs">{{ planRecoveryType(row.plan) }}</td>
                                    <td>
                                        <b v-if="row.loanAmount">{{row.loanAmount}}</b>
                                        <b v-else>{{ planAmt(row.plan) }}</b>
                                    </td>
                                    <td class="hidden-xs">{{ loanTenure(row.plan) }}</td>
                                    <td></td>
                                    <!-- <td class="hidden-xs">{{ row.disbursementDate | myDate }}</td>
                                    <td class="hidden-xs">{{ row.emiStartDate | myDate }}</td>
                                    <td class="hidden-xs">{{ row.emiEndDate | myDate }}</td> -->
                                    
                                    
                                    <!-- <td class="hidden-xs"><span v-if="row.agent">{{ row.agent.name }}</span></td> -->
                                    <!-- <td class="hidden-xs">
                                    {{row.branch_ledger.ledger.name}}
                                    </td> -->
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="7">
                                        <strong>Spouse : {{row.member.member_profile.spouseName}}</strong>
                                        <strong>Staff :</strong> {{ row.agent.name }} 
                                        <span v-if="Object.keys(collectionCenter).length === 0"><strong>&nbsp;&nbsp;&nbsp;&nbsp; Group Name :</strong> {{ row.collection_center.name }} ({{ row.collection_center.centerCode }})</span>
                                        <span>&nbsp;&nbsp;&nbsp;&nbsp; <strong>File Charge :</strong> {{ loanFileCharge(row.plan) }}</span>
                                        <span>&nbsp;&nbsp;&nbsp;&nbsp; <strong>EMI :</strong> <i v-if="loanEMI(row.plan) !== 0">{{ loanEMI(row.plan) }}</i></span>
                                    </td>
                                    <td>Date: </td>
                                  </tr>
                                </tbody>
                            </table>
                                    
                            </div>
                            <!-- /.box-body -->
                        </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    
</template>
<script>
import VueBarcode from 'vue-barcode'
export default {
  name: 'PrintViewDisbursementCollectionCenterWise',
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    planName (plan) {
      var pln = JSON.parse(plan)
      return pln.name
    },
    planRecoveryType (plan) {
      var pln = JSON.parse(plan)
      return pln.recoveryType
    },
    planAmt (plan) {
      var pln = JSON.parse(plan)
      return pln.amount
    },
    loanTenure (plan) {
      var pln = JSON.parse(plan)
      return pln.noOfPayments
    },
    loanFileCharge (plan) {
      var pln = JSON.parse(plan)
      return pln.fileCharge
    },
    loanEMI (plan) {
      var pln = JSON.parse(plan)
      return pln.emi
    },
    printdisbursementcollectioncenterwise () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('printdisbursementcollectioncenterwise').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }
  },
  components: {
    'barcode': VueBarcode
  },
  props: {
    seeRecords: {},
    memberDetail: {},
    logo: '',
    branch: {},
    collectionCenter: {},
    getCompanyRecord: {}
  }
}
</script>



// WEBPACK FOOTER //
// PrintViewDisbursementCollectionCenterWise.vue?f9249a74